import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "bank" }
const _hoisted_3 = {
  href: "https://bank.gov.ua/ua/open-data/api-dev",
  title: "In more detail...",
  target: "_blank"
}
const _hoisted_4 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CurrentDate = _resolveComponent("CurrentDate")!
  const _component_NBURates = _resolveComponent("NBURates")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('project4.name')), 1),
    _cache[2] || (_cache[2] = _createElementVNode("line", null, null, -1)),
    _createVNode(_component_CurrentDate),
    _createElementVNode("h1", _hoisted_2, [
      _createElementVNode("a", _hoisted_3, _toDisplayString(_ctx.$t('nbu')), 1),
      _cache[1] || (_cache[1] = _createTextVNode()),
      _createElementVNode("i", {
        title: [_ctx.tableView ? 'Start viewing in List view' : 'Start viewing in Table view'],
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeView && _ctx.changeView(...args)))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(['fa', _ctx.tableView ? 'fa-list' : 'fa-th'])
        }, null, 2)
      ], 8, _hoisted_4)
    ]),
    _createVNode(_component_NBURates, { "table-view": _ctx.tableView }, null, 8, ["table-view"])
  ]))
}